import { Editor, Element, Transforms } from 'slate';

import { createBlockNode, SLATE_TEXT_FORMATS } from 'src/lib/slate';

export const withNormalizedPlaceholder = (editor, options) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    // Reset formatting of the single empty node, so placeholder will always look the same
    if (Element.isElement(node)) {
      const isSingleNode = editor.children.length === 1;
      const isNodeEmpty = Editor.isEmpty(editor, node);
      if (isSingleNode && isNodeEmpty) {
        const node = createDefaultNode(options);
        Transforms.setNodes(editor, node, { at: path });
      }
    }

    // Fall back to the original `normalizeNode` to enforce other constraints.
    normalizeNode(entry);
  };

  return editor;
};

const createDefaultNode = (options) => {
  const defaultTextFormat = options?.defaultTextFormat || SLATE_TEXT_FORMATS.PARAGRAPH;
  return createBlockNode(defaultTextFormat, [{ text: '' }]);
};
